let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("cMlHc")]).then(() => parcelRequire('2v58P'));